import { render, staticRenderFns } from "./SpecialityPartnersGroup.vue?vue&type=template&id=ecb4371e&scoped=true&"
import script from "./SpecialityPartnersGroup.vue?vue&type=script&lang=js&"
export * from "./SpecialityPartnersGroup.vue?vue&type=script&lang=js&"
import style0 from "./SpecialityPartnersGroup.vue?vue&type=style&index=0&id=ecb4371e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb4371e",
  null
  
)

export default component.exports